import Vue from 'vue'
import Vuex from 'vuex'

import errorMessage from '@/stores/modules/error-message'
import auth from '@/stores/modules/auth'
import router from '@/stores/modules/router'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const actions = {

}

const getters = {

}

export default new Vuex.Store({
	actions,
	getters,
	modules: {
		errorMessage,
		auth,
		router
	},
	strict: debug,
})
